import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const shoppingCartItemSchema = surrealRecordSchema.extend({
  value: z.string(),
  checked: z.boolean().default(false),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export const shoppingCartItemsSchema = z.array(shoppingCartItemSchema);

export const shoppingCartItemCreateSchema = shoppingCartItemSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const shoppingCartItemUpdateSchema = shoppingCartItemSchema.partial();

export type ShoppingCartItem = z.infer<typeof shoppingCartItemSchema>;
export type ShoppingCartItemCreate = z.infer<
  typeof shoppingCartItemCreateSchema
>;
export type ShoppingCartItemUpdate = z.infer<
  typeof shoppingCartItemUpdateSchema
>;
